<template>
	<div>
		<div class="flexCol alit" style="position: relative;width:100%;height: 100%;">
			<div id="bottomLeft" style="width:100%;height:100%;position: relative;z-index: 9;margin-top: -8%;"></div>
			<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/hotpot/brain/bottom/fuwu2.png"
				class="bg2"></img>
		</div>

	</div>
</template>

<script>
	import * as echarts from 'echarts'
	import 'echarts-gl'
	export default {
		data() {
			return {
				data: []
			}
		},
		mounted() {
			// this.$request('/center/home/middleBottomOne').then(res => {
			// 	for (var i = 0; i < res.data.length; i++) {
			// 		res.data[i].name = res.data[i].type
			// 		res.data[i].value = (Math.abs(res.data[i].count) / 10000).toFixed(2)
			// 	}
			// 	this.init(res.data);
			// })
			this.init();
		},
		methods: {
			init() {
				let that = this
				let myChart = echarts.init(document.getElementById("bottomLeft"), "purple-passion");
				//随着屏幕大小调节图表
				window.addEventListener("resize", () => {
					myChart.resize();
				});


				let chartData = [{
					name: '供应商',
					value: 435,
					unit:'个'
				}, {
					name: '采购商',
					value: 1863,
					unit:'个'
				}, {
					name: '火锅门店',
					value: 597,
					unit:'家'
				}]
				// 字段值对齐，不足补空格
				let fixWithWhiteSpace = (maxLen, text, prefix = true) => {
					if (text && maxLen) {
						let num = maxLen - text.length
						return prefix && num > 0 ? Array(num + 1).join('  ') + text : text + Array(num + 1).join('   ')
					}
					return text
				}
				var option = {
					color: ['#F4DF58', '#333FFF', '#FFB0E3', '#00FFA6', '#7A79FF'],

					grid: {
						left: '0%',
						right: '0%',
						bottom: '0%',
						top: '0%',
						containLabel: true,
					},
					// graphic: {
					// 	type: "image",
					// 	z: 1,
					// 	style: {
					// 		// image: 'data:image/png;base64,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',
					// 		image: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/hotpot/brain/bottom/fuwu2.png',
					// 		width: 160,
					// 		height: 160
					// 	},
					// 	left: '6%',
					// 	top: 'center',
					// 	scale: [1.0, 1.0], //缩放
					// 	// left: 'center',
					// 	// top: 'center',
					// 	position: [10, 10],
					// 	bounding: 'raw',
					// },
					tooltip: {
						confine: true,
					},
					legend: {
						selectedMode: true,
						orient: 'vertical',
						right: 10,
						top: '35%',
						textStyle: {
							fontSize: 12,
							color: '#fff',
							verticalAlign: 'middle',
						},
						itemWidth: 10,
						itemHeight: 10,
						formatter(name) { // 该函数用于设置图例显示后的百分比
							let data = chartData
							// let data = [{
							// 	name:'供应商',
							// 	value:125
							// },{
							// 	name:'采购商',
							// 	value:310
							// },{
							// 	name:'火锅门店',
							// 	value:367
							// }]
							let total = 0
							let value = 0
							let unit = ''
							data.forEach((item) => {
								total += Number(item.value)
								if (item.name == name) {
									value = Number(item.value)
									unit = item.unit
								}
							})
							console.log(total);
							// let p = ((value / total) * 100).toFixed(1) // 求出百分比
							let p = value
							let maxNamelen = Math.max(...data.map(p => p.name.length))
							let maxValuelen = Math.max(...data.map(p => (p.value + '').length))
							let maxPercentageLen = Math.max(...data.map(p => ((p.value / total) * 100).toFixed(1)
								.length))
							// 返回出图例所显示的内容是名称+百分比
							return [`{c|${fixWithWhiteSpace(maxNamelen, name, false)}}` + '{b|' +
								`${fixWithWhiteSpace(maxValuelen, (p || 0).toString())}` + unit + '}'
							]
						},
						textStyle: {
							rich: {
								b: {
									padding: [0, 0, 0, 0],
									fontSize: 12,
									color: '#fff'
								},
								c: {
									padding: [0, 15, 0, 0],
									fontSize: 12,
									color: '#fff'
								},
							},
						},
					},
					series: [{
						name: '',
						type: 'pie',
						radius: ['55%', '70%'],
						center: ['30%', '50%'],
						avoidLabelOverlap: false,
						itemStyle: {},
						label: {
							show: false,
							position: 'center',
						},
						labelLine: {
							show: false,
						},
						data: chartData,
					}, ],
				};

				myChart.setOption(option);
				setInterval(function() {
					myChart.clear()
					myChart.setOption(option);
				}, 15000)

			}
		}
	}
</script>

<style scoped>
	.sycw {
		font-size: 72rpx;
		font-family: DingTalk JinBuTi, DingTalk JinBuTi;
		font-weight: 900;
		color: #FFFFFF;
		text-shadow: 0px 8rpx 20rpx rgba(0, 0, 0, 0.8);
		-webkit-background-clip: text;
		-webkit-text-fill-color: #ffedf6;
	}

	.title {
		font-size: 24rpx;
		font-family: Source Han Sans, Source Han Sans;
		font-weight: 400;
		color: #dbecff;
		line-height: 40px;
		margin-left: 20rpx;
	}

	.bg2 {
		position: absolute;
		height: 15vh;
		width: 7.5vw;
		background-size: 100% 100%;
		top: 4%;
		left: 1.3vh;
		left: 8%
			/* z-index: inherit; */
	}
</style>